(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sold-out-drop-notification-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
  'submit',
  /**
   * @param {SubmitEvent} event
   */
  function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.sold-out-drop__native-form')) return;
    // TODO: confirm phone + sms_consent write to Shopify SMS marketing consent field
  },
  true
);
  } catch(e) { console.error(e); }
})();

})();
